import { PropertyInformationPopoverContentUI } from './PropertyInformationPopoverContentUI';
import { useContext } from 'react';
import SegmentationFiltersSharedContext from '../../state/SegmentationFiltersSharedContext';
import DSFieldRecord from '../../filterQueryFormat/DSFieldRecord/DSFieldRecord';
import { getOverriddenPropertyType } from '../../utils/getIconComponent';
import { useStrategy } from '../../hooks/useStrategy';
import { getPropertySettingsLink } from '../../api/propertySettingsUILinks';
import { useAwaitedState } from '../../hooks/useAwaitedState';
import PropertyInformationPopoverError from './PropertyInformationPopoverError';
import { jsx as _jsx } from "react/jsx-runtime";
export const PropertyInformationPopoverContent = ({
  filterFamily,
  propertyName
}) => {
  var _useStrategy$getField, _usagesResult$value, _getPropertySettingsL, _getPropertySettingsL2;
  const {
    data,
    getPropertyUsagesCached,
    getIsUngated
  } = useContext(SegmentationFiltersSharedContext);
  const propertyInfo = data.getIn([filterFamily, propertyName], undefined);
  const filterField = (_useStrategy$getField = useStrategy().getFields(filterFamily)) === null || _useStrategy$getField === void 0 ? void 0 : _useStrategy$getField.get(propertyName);
  const usagesResult = useAwaitedState(getPropertyUsagesCached(filterFamily));
  if (!propertyInfo && !filterField && usagesResult.state === 'rejected') {
    return /*#__PURE__*/_jsx(PropertyInformationPopoverError, {});
  }

  // If the field is returned by strategy.getFields but not referenceResolvers
  //   we will assume that it's a virtual field
  const isVirtualField = typeof filterField !== 'undefined' && typeof propertyInfo === 'undefined';
  const usageCount = usagesResult.state === 'fulfilled' && !isVirtualField ? (_usagesResult$value = usagesResult.value[`${filterFamily}/${propertyName}`]) !== null && _usagesResult$value !== void 0 ? _usagesResult$value : 0 : undefined;
  const field = [filterField, propertyInfo].find(DSFieldRecord.isDSFieldRecord);
  const propertyType = field ? getOverriddenPropertyType(field, getIsUngated, filterFamily) : undefined;
  return /*#__PURE__*/_jsx(PropertyInformationPopoverContentUI, {
    loading: usagesResult.state === 'pending',
    label: field === null || field === void 0 ? void 0 : field.label,
    description: field === null || field === void 0 ? void 0 : field.description,
    propertyType: propertyType,
    fieldType: field === null || field === void 0 ? void 0 : field.fieldType,
    usageCount: usageCount,
    editLink: !isVirtualField ? (_getPropertySettingsL = getPropertySettingsLink(filterFamily, propertyName, 'edit')) !== null && _getPropertySettingsL !== void 0 ? _getPropertySettingsL : undefined : undefined,
    usagesLink: !isVirtualField ? (_getPropertySettingsL2 = getPropertySettingsLink(filterFamily, propertyName, 'usage')) !== null && _getPropertySettingsL2 !== void 0 ? _getPropertySettingsL2 : undefined : undefined
  });
};